import { createDefaultTyrann } from '@apis/common';
import {
  bookingInquiryStatus,
  bookingInquiryMemo,
  adminInquiry,
  adminInquiryDetail,
  inquiryStatus,
  patchBookingInquiry,
} from '@models/BookingInquiry';
import { bookingInquiryChangeLog } from '@models/BookingInquiryChangeLog';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const bookingInquiryQuery = t.partial({
  page: t.number,
  page_size: h.omittableNumber().cast(),
  member_no: t.string,
  d2d_no: t.string,
  company_name: t.string,
  ordering: t.string,
  created_at_before: t.string,
  created_at_after: t.string,
  status: h.array(inquiryStatus),
  salesperson_japan_id: h.number().cast(),
  salesperson_china_id: h.number().cast(),
  member_salesperson_id: h.number().cast(),
  agency_id: h.number().cast(),
  email: h.string(),
  fullname: h.string(),
});

export type BookingInquiryQuery = t.TypeOf<typeof bookingInquiryQuery>;

export const bookingInquiryApis = createDefaultTyrann({
  '/dashboard/booking-inquiry/{d2d_no}/status/': {
    get: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: bookingInquiryStatus,
      },
    },
    patch: {
      path: t.type({
        d2d_no: t.string,
      }),
      body: bookingInquiryStatus,
      response: {
        200: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/booking-inquiry/{d2d_no}/memo/': {
    get: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: bookingInquiryMemo,
      },
    },
    patch: {
      path: t.type({
        d2d_no: t.string,
      }),
      body: bookingInquiryMemo,
      response: {
        200: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/booking-inquiry/{d2d_no}/salesperson-china/': {
    post: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/booking-inquiry/{d2d_no}/salesperson-japan/': {
    post: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/booking-inquiry/{d2d_no}/salesperson-customs/': {
    post: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/booking-inquiry/': {
    get: {
      query: bookingInquiryQuery,
      response: {
        200: t.type({
          count: t.number,
          results: t.array(adminInquiry),
        }),
      },
    },
  },
  '/dashboard/booking-inquiry/{d2d_no}/': {
    get: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: adminInquiryDetail,
      },
    },
    patch: {
      path: t.type({
        d2d_no: t.string,
      }),
      body: patchBookingInquiry,
      response: {
        200: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/booking-inquiry/{d2d_no}/logs/': {
    get: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: t.array(bookingInquiryChangeLog),
      },
    },
  },
  '/dashboard/booking-inquiry/{d2d_no}/owner/': {
    patch: {
      path: t.type({
        d2d_no: t.string,
      }),
      body: t.type({
        owner: t.number,
      }),
      response: {
        200: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
});
